import { render } from "./product_receipt.vue?vue&type=template&id=9bfccd20&scoped=true"
import script from "./product_receipt.vue?vue&type=script&lang=js"
export * from "./product_receipt.vue?vue&type=script&lang=js"

import "./product_receipt.vue?vue&type=style&index=0&id=9bfccd20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfccd20"]])

export default __exports__